import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { QrCodeComponent } from './qr-code.component';

@NgModule({
    imports: [ QrCodeComponent ]
})
export class QrCodeModule {
    constructor(private injector: Injector) {
        const el = createCustomElement(QrCodeComponent, {
            injector: this.injector
        });
        customElements.define('dash-gis-qr-code', el);
    }
}
